export default {
  tit: "管理系统",//标题
  logo:require('../assets/logo.png'),
  userIco:require('../assets/img/avatar.jpg'),//用户默认头像
  head:{
    background:'#409EFF',//头部背景色
    userNameColor:'#fff',//用户名称颜色
    userOutColor:'#fff',//用户退出按钮颜色
  },
  headTab:{//顶部导航记录标签
    isShow: true,//是否显示
    type:'',//类型 success/info/warning/danger
    size:'medium',//尺寸  medium / small / mini
    background:'',//背景色会覆盖原有的类型颜色
    effect:'plain',//默认主题 dark / light / plain
    actEffect:'dark',//当前页面标签主题 dark / light / plain
  },
  menu:{
    disjunctorIcoColor:'#fff',//导航显示隐藏icon颜色
    background:'rgb(48, 65, 86)',//导航背景颜色
    fatherBackground:'#1f2d3d',//父级展开背景色
    iconColor:'#909399',//导航icon颜色
    fontColor:'rgb(191, 203, 217)',//导航字体颜色
    hoverBackground:'#001528',//导航鼠标指向背景颜色
    hoverColor:'rgb(191, 203, 217)',//导航鼠标指向字体
    actBackground:'#409EFF',//导航选中背景
    actColor:'#fff',//导航选中背景
  },
}



// WEBPACK FOOTER //
// ./src/layout/sysConfig.js